import React, { useState, useEffect } from "react";
import axios from "../../api/axios.js";
import {
  convertIntoSelect2Options,
  getFetchOptions,
} from "../../js/utility.js";
import Breadcrumb from "../utils/Breadcrumb.jsx";
import Select from "react-select";

const ChallengesLayout = () => {
  const [challenges, setChallenges] = useState([]);

  const userSchoolId = localStorage.getItem("userSchoolId");
  const userId = localStorage.getItem("userId");

  const breadcrumb = {
    current_section: "Elenco challenges",
    sections: [
      { name: "Challenges", route_name: null, params: [] },
      { name: "Elenco challenges", route_name: null, params: [] },
    ],
  };

  useEffect(() => {
    const fetchChallenges = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getAllChallenges?schoolId=${userSchoolId}&teacherId=${userId}`,
          fetchOptions
        );
        const result = await response.json();
        if (!result.error) {
          setChallenges(result);
        } else {
          setChallenges([]);
          console.error("Error fetching users:", result.message);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchChallenges();
  }, []);

  const handleDelete = async (id) => {
    try {
      const fetchOptions = getFetchOptions(
        "application/x-www-form-urlencoded",
        [],
        "DELETE"
      );
      const response = await fetch(
        `${axios.defaults.baseBFFUrl}/fe/deleteChallenge?challengeId=${id}`,
        fetchOptions
      );
      const result = await response.json();

      if (!result.error) {
        alert("Challenge terminata con successo");
        window.location.reload();
      } else {
        console.error("Error deleting challenge:", result.message);
        alert("Errore durante l'eliminazione della challenge");
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="container-fluid">
      <Breadcrumb breadcrumb={breadcrumb} />

      {/* Challenges List Card */}
      <div className="card custom-card">
        <div className="card-header card-title">Elenco Challenges</div>
        <div className="card-body">
          <div className="table-responsive" id="table_result">
            <table
              className="table text-nowrap table-bordered"
              id="datatable-basic"
            >
              <thead>
                <tr>
                  <th scope="col">Titolo</th>
                  <th scope="col">Data Inizio</th>
                  <th scope="col">Ora Inizio</th>
                  <th scope="col">Data Fine</th>
                  <th scope="col">Ora Fine</th>
                  <th scope="col">Status</th>
                </tr>
              </thead>
              <tbody>
                {challenges &&
                  challenges.map((challenge, index) => (
                    <tr key={index}>
                      <td>{challenge.titolo}</td>
                      <td>
                        {challenge.datainizio
                          ? new Date(challenge.datainizio).toLocaleDateString(
                              "it-IT"
                            )
                          : ""}
                      </td>
                      <td>{challenge.orainizio}</td>
                      <td>
                        {challenge.datafine == null
                          ? "In giornata"
                          : new Date(challenge.datafine).toLocaleDateString(
                              "it-IT"
                            )}
                      </td>
                      <td>
                        {challenge.orafine == null
                          ? "In giornata"
                          : challenge.orafine}
                      </td>
                      <td>{challenge.status}</td>
                      <td>
                        <div className="btn-list">
                          <button
                            className="btn btn-sm btn-warning"
                            onClick={() => {
                              window.location.href = `/challenges/edit/${challenge.id}`;
                            }}
                            disabled={
                              challenge.status !== "Planned" ? true : false
                            }
                          >
                            <i className="align-middle bi bi-pencil"></i>
                          </button>
                          <button
                            className="btn btn-sm btn-info"
                            onClick={() => {
                              window.location.href = `/challenges/detail/${challenge.id}`;
                            }}
                          >
                            <i className="align-middle bi bi-eye"></i>
                          </button>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => {
                              if (
                                window.confirm(
                                  "Sei sicuro di voler terminare questa challenge?"
                                )
                              ) {
                                handleDelete(challenge.id);
                              }
                            }}
                          >
                            <i className="align-middle bi bi-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChallengesLayout;
